module.exports = __webpack_public_path__ + "static/media/screenshot-4.80339d32.png";